import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const pages = {
  home: {
    title: "RedDawg Tech LLC | IT Consulting, DevOps & Cybersecurity",
    description: "RedDawg Tech delivers IT consulting, DevOps engineering, software development, cybersecurity, and automation solutions for small businesses.",
  },
  services: {
    title: "Services | RedDawg Tech LLC",
    description: "Explore RedDawg Tech's website development, cloud infrastructure, security, automation, and application-development services.",
  },
  about: {
    title: "About | RedDawg Tech LLC",
    description: "Learn about RedDawg Tech LLC and the technical services we provide to small businesses.",
  },
  stack: {
    title: "Technology Stack | RedDawg Tech LLC",
    description: "See the technologies and platforms used by RedDawg Tech to build and operate reliable solutions.",
  },
  projects: {
    title: "Projects | RedDawg Tech LLC",
    description: "Explore RedDawg Tech project demonstrations and technical capabilities.",
  },
};

function Seo({ page }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const metadata = pages[page] || pages.home;
    const canonical = `https://reddawgtech.com${pathname === "/" ? "/" : pathname}`;

    document.title = metadata.title;
    document.querySelector('meta[name="description"]')?.setAttribute("content", metadata.description);
    document.querySelector('meta[property="og:title"]')?.setAttribute("content", metadata.title);
    document.querySelector('meta[property="og:description"]')?.setAttribute("content", metadata.description);
    document.querySelector('meta[property="og:url"]')?.setAttribute("content", canonical);
    document.querySelector('link[rel="canonical"]')?.setAttribute("href", canonical);
  }, [page, pathname]);

  return null;
}

export default Seo;
